<!-- 我的 -->

<template>
    <div class="learingArea">
        <backHeader back-addr="/course"></backHeader>
        <div style="height:10px;"></div>
        <div class="" style="margin-bottom:10px;padding-left:10px;padding-right:10px;border-bottom:1px solid #BBBBBB;" v-for="ne in nes">
            <div class="" style="display:block;height:30px;">
                <div class="" style="position:absolute;left:10px;">
                    <img class="" :src="$route.query.img" style="height:18px;width:18px;vertical-align:text-top;margin-right:4px;">
                    <span>{{$route.query.name}}</span>
                    <!-- <span>{{ne.school}}</span> -->
                </div>
                <div class="" style="position:absolute;right:10px;">
                    <img class="" :src="collection" style="height:18px;width:18px;vertical-align:text-top;margin-right:4px;">
                    <span>收藏</span>

                </div>
                <!-- <div class="">
                    <img class="" :src="comment" style="height:18px;width:18px;vertical-align:text-top;margin-right:4px;">
                    <span>评论</span>
                </div> -->
            </div>
            <div class="" style="display:block;">
                <div class="">

                </div>
                <div class="">
                    <h4>{{ne.title}}</h4>
                </div>
            </div>
            <div class="" style="display:block;">
                <div class="">

                </div>
                <div class="">
                    <img class="" :src="ne.cut" style="width:100%;vertical-align:text-top;margin-bottom:10px;">
                </div>
                <div class="">

                </div>
            </div>
        </div>
        <div style="height:60px;"></div>
    </div>
</template>

<script>
    import comment from './img/ne/comment1.png';
	import collection from './img/ne/collection1.png'

    import backHeader from "./../components/back-header.vue";
    export default {
        components: {
            backHeader
        },
        data() {
            return {
                comment:comment,
                collection:collection,
                nes: [{
                        school: "哈尔滨医科大学",
                        title: "习近平新时代中国特色社会主义思想专题辅导课",
                        teacher: "马林老师",
                        img: require("./img/ne/school1.png"),
                        avatar: require("./img/ne/head.jpg"),
                        cut: require("./img/ne/total1.png"),
                        link: ""
                    },
                    {
                        school: "哈尔滨医科大学",
                        title: "毛泽东思想和中国特色社会主义体系概论",
                        teacher: "陈泽老师",
                        img: require("./img/ne/school1.png"),
                        avatar: require("./img/ne/head2.png"),
                        cut: require("./img/ne/total1.png"),
                        link: ""
                    },
                    {
                        school: "哈尔滨医科大学",
                        title: "中国近代史纲要",
                        teacher: "李斌老师",
                        img: require("./img/ne/school1.png"),
                        avatar: require("./img/ne/head3.png"),
                        cut: require("./img/ne/total1.png"),
                        link: ""
                    },
                    {
                        school: "哈尔滨医科大学",
                        title: "思想道德修养与法律基础",
                        teacher: "张泽老师",
                        img: require("./img/ne/school1.png"),
                        avatar: require("./img/ne/head4.png"),
                        cut: require("./img/ne/total1.png"),
                        link: ""
                    },
                    {
                        school: "哈尔滨医科大学",
                        title: "形势与政策",
                        teacher: "张泽老师",
                        img: require("./img/ne/school1.png"),
                        avatar: require("./img/ne/head4.png"),
                        cut: require("./img/ne/total1.png"),
                        link: ""
                    },
                    {
                        school: "哈尔滨医科大学",
                        title: "马克思主义基本原理概论",
                        teacher: "张泽老师",
                        img: require("./img/ne/school1.png"),
                        avatar: require("./img/ne/head4.png"),
                        cut: require("./img/ne/total1.png"),
                        link: ""
                    }
                ],
                funcs: [{
                        name: "校院班子联系点",
                        url: require("./img/1.png")
                    },
                    {
                        name: "兼职班主任",
                        url: require("./img/2.png")
                    },
                    {
                        name: "导师负责制",
                        url: require("./img/3.png")
                    },
                    {
                        name: "党员群众手牵手",
                        url: require("./img/4.png")
                    }
                ]
            };
        },
        props: {},
        watch: {},
        methods: {
            goArea() {
                this.$router.push();
            },
            login() {
                this.$router.push({
                    path: "/login/"
                });
            },
            go(type) {
                this.$router.push("./" + type + "/");
            }
        },
        filters: {},
        computed: {},
        created() {},
        mounted() {},
        destroyed() {}
    };
</script>

<style lang="scss" scoped>
    @import "../assets/baseScss";
    // .mui-ios .mui-table-view-cell {
    //   display: inline-block;
    //   border: 0px 1px 1px 0px solid black;
    // }
    // .mui-ios .mui-table-view-cell:after {
    //   background-color: white!important;
    // }
    .mui-row {
      margin-top:8px;
      margin-bottom: 8px;
    }

    .mui-media-body {
        position: absolute;
        top: 25px;
        left: 80px;
    }
    
    .cross-line {
        height: 7px!important;
    }
</style>


// WEBPACK FOOTER //
// src/module-area/area.vue